import React from 'react'
import'./Privacidad.css'
import { Footer } from '../Footer/Footer'

export const Privacidad = () => {
  return (
    <div>
       
  <div className="container privacidad">
    <h1> Protección de datos personales</h1>
    <br/>
    <p>En general, es posible navegar en el sitio web de Geocartos sin revelar su identidad o proporcionar información personal. Nuestro servidor no recolecta direcciones de correo electrónico, solo recaba información para medir número de visitas, tiempo promedio de permanencia en el sitio, secciones vistas, etc.</p>
    <p>Por otro lado hay ocasiones que necesitemos información tal como su nombre y dirección, cuando esto suceda le haremos saber que trato se le va a dar a la información recabada. En general, la información personal que recopilamos es usada solamente por nosotros para responder a sus consultas, procesar su pedido y permitirle acceder a información muy específica de nuestros servicios.</p>
    <p className="text-muted">Geocartos S.A. de C.V. no revela ni comercia la información que recopila a terceros.</p>
    <p> Nuestro sitio web puede contener enlaces a otros sitios. Aunque tratamos de mantener enlaces con sitios que comparten nuestro respeto por la privacidad, no somos de ninguna manera responsables por el contenido o las políticas de privacidad empleadas por otros sitios. </p>
    <p>En Geocartos S.A. de C.V. son bienvenidos sus comentarios respecto a esta declaración de privacidad, por favor póngase en contacto con nosotros por correo electrónico (contacto@geocartos.com).</p>
    
<br/>
  
  
   <h1> Aviso legal</h1>
   <br/>
   <p>Al visitar y utilizar www.geocartos.com usted acepta los siguientes términos y condiciones: este sitio web, incluyendo los contenidos y la información de cada sección son propiedad exclusiva de Geocartos S.A. de C.V. Todos los derechos reservados.</p>
   <p>Se le permite almacenar extractos de nuestro sitio web en su ordenador e imprimir copias de los mismos para su uso personal, mas no comercial. Queda prohibido cualquier otro tipo de uso, reproducción, traducción, adaptación, arreglo, cualquier otra alteración, distribución o almacenamiento de este sitio en cualquier forma y por cualquier medio, en todo o en parte, sin el permiso previo por escrito de Geocartos S.A. de C.V.</p> 
   <p>La información contenida en nuestro sitio web puede no ser exacta o aplicable a casos particulares. Geocartos S.A. de C.V. no se hace responsable por inexactitud u omisión. Cualquier decisión que usted tome basándose en la información contenida en este sitio web son bajo su propia responsabilidad. </p>
  </div>

  <Footer />

    </div>
  )
}
